import React, { useState, useEffect } from 'react';
import {
  listWithdrawals, markWithdrawalPaid, processWithdrawalViaPaystack, rejectWithdrawal
} from '../../services/adminMarketplaceService';
import ConfirmDialog from '../ui/ConfirmDialog';
import { useToast } from '../../context/ToastContext';

const WithdrawalQueue = () => {
  const toast = useToast();
  const [requests, setRequests] = useState([]);
  const [reference, setReference] = useState({});
  const [rejectTarget, setRejectTarget] = useState(null);
  const [rejectReason, setRejectReason] = useState('');

  const refresh = () => listWithdrawals('pending').then(setRequests);
  useEffect(() => { refresh(); }, []);

  const handleMarkPaid = async (id) => {
    await markWithdrawalPaid(id, reference[id] || '', 'Manually paid by admin');
    toast.success('Marked as paid');
    refresh();
  };

  const handlePaystack = async (id) => {
    try {
      await processWithdrawalViaPaystack(id);
      toast.success('Transfer sent via Paystack');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Paystack transfer failed');
    }
    refresh();
  };

  const confirmReject = async () => {
    await rejectWithdrawal(rejectTarget, rejectReason);
    setRejectTarget(null);
    setRejectReason('');
    toast.success('Withdrawal rejected and funds returned to wallet');
    refresh();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Pending withdrawals</h2>
      {requests.map(r => (
        <div key={r._id} className="bg-white p-4 rounded-lg shadow space-y-2">
          <p className="font-semibold">
            {r.userId?.firstName} {r.userId?.lastName} ({r.role}) — ₦{r.amount.toLocaleString()}
          </p>
          <p className="text-sm text-gray-600">{r.userId?.email} — {r.userId?.phone}</p>
          <p className="text-xs text-gray-500">Requested {new Date(r.requestedAt).toLocaleString()}</p>

          <div className="flex gap-2 flex-wrap items-center pt-2">
            <input
              placeholder="Bank transfer reference"
              value={reference[r._id] || ''}
              onChange={(e) => setReference({ ...reference, [r._id]: e.target.value })}
              className="p-2 border rounded-lg text-sm flex-1 min-w-[180px]"
            />
            <button onClick={() => handleMarkPaid(r._id)} className="bg-green-600 text-white px-3 py-1.5 rounded-lg text-sm">
              Mark as manually paid
            </button>
            <button onClick={() => handlePaystack(r._id)} className="bg-black text-white px-3 py-1.5 rounded-lg text-sm">
              Process via Paystack
            </button>
            <button onClick={() => setRejectTarget(r._id)} className="bg-red-100 text-red-700 px-3 py-1.5 rounded-lg text-sm">
              Reject
            </button>
          </div>
        </div>
      ))}
      {requests.length === 0 && <p className="text-gray-500">No pending withdrawals.</p>}

      <ConfirmDialog
        open={!!rejectTarget}
        title="Reject this withdrawal?"
        message="The requested amount will be returned to the user's wallet."
        confirmLabel="Reject"
        danger
        reason={rejectReason}
        onReasonChange={setRejectReason}
        reasonLabel="Reason for rejecting"
        reasonRequired
        onConfirm={confirmReject}
        onCancel={() => { setRejectTarget(null); setRejectReason(''); }}
      />
    </div>
  );
};

export default WithdrawalQueue;
